import { Navigate, useParams } from 'react-router';

import { type Category, CategoryView } from './CategoryView';

const CATEGORIES: readonly Category[] = [
  'boards',
  'team-boards',
  'workspaces',
  'databases',
  'favorites',
];

/** `/app/browse/:category`: the full-screen category view. */
export function CategoryPage() {
  const { category } = useParams();
  const known = CATEGORIES.find((value) => value === category);
  if (!known) return <Navigate to="/app" replace />;
  return <CategoryView category={known} />;
}
